<template>
  <div class="cmp-wrapper">
    <basic-container>
      <el-form inline :model="formData" ref="splitAccountManage">
        <el-form-item label="分账主体名称">
          <el-input style="margin-left:10px;" v-model="formData.subjectName" placeholder="请输入主体名称"/>
        </el-form-item>
        <el-select style="margin-left:10px;" v-model="selectStore" @change="selectBtn">
          <el-option label="门店ID" value="1"></el-option>
          <el-option label="门店名称" value="2"></el-option>
        </el-select>
        <el-form-item prop="storeId1" v-if="selectStore == 1" style="margin-left:10px;">
          <el-input v-model="storeId1" placeholder="请输入门店ID"></el-input>
        </el-form-item>
        <el-form-item prop="storeId2" v-if="selectStore == 2" style="margin-left:10px;">
          <fuzzy-query
            ref="cusOption2"
            :valueId.sync="storeId2"
            typeKey="storeName"
            :option="cusOption2"
          ></fuzzy-query>
        </el-form-item>
        <el-form-item>
            <el-button icon="el-icon" type="primary" @click="subjectSearch" style="margin:0 10px">查询</el-button>
            <el-button icon="el-icon-plus" type="primary" @click="addSubject" style="margin:0 10px">新建</el-button>
        </el-form-item>
      </el-form>

      <div class="show-settle" v-if="totalWaitSettleAmount">
        待结算总金额：: <span style="font-size: 30px; color: red"> {{totalWaitSettleAmount}}元</span>
      </div>
      
      <el-table v-loading="loading" :data="tableData">
        <el-table-column label="ID" align="center" width="150px" prop="id"></el-table-column>
        <el-table-column label="分账主体名称" align="center" width="150px" prop="name"></el-table-column>
        <el-table-column label="收款银行卡" align="center" width="150px" prop="cashAccountCode">
          <template slot-scope="scope">
            <span v-if="scope.row.cashAccountCode">{{scope.row.cashAccountCode}}</span>
            <el-button 
              class="operateBtn" 
              type="text"
              v-if="shouldShowButton(scope.row)" 
              @click="addCashAccount(scope.row)">添加银行卡
            </el-button>
          </template>
        </el-table-column>
        <el-table-column label="待结算金额" align="center" width="150px" prop="waitSettleAmount"></el-table-column>
        <el-table-column label="账户欠款" align="center" width="150px" prop="accountDebt"></el-table-column>
        <el-table-column label="结算周期" align="center" width="100px" prop="settlementPeriod"></el-table-column>
        <el-table-column label="收款门店" align="center" width="120px">
          <template slot-scope="scope">
            <el-button 
              class="operateBtn" 
              type="text" 
              @click="listCompany(scope.row)">查看详情
            </el-button>
          </template>
        </el-table-column>
        <el-table-column label="状态" align="center" width="100px" prop="stateName"></el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button
                class="operateBtn"
                type="text"
                v-if="scope.row.payClearSettlementId!=null"
                @click="removeCashAccount(scope.row)">解绑银行卡
            </el-button>
            <el-button class="operateBtn" type="text" @click="toDetail(scope.row, '1')">查看</el-button>
            <el-button
              class="operateBtn"
              type="text"
              v-if="scope.row.state=== 1"
              @click="toDetail(scope.row, '2')"
            >编辑</el-button>
            <el-button
              class="operateBtn"
              type="text"
              v-if="scope.row.state=== 4"
              @click="toBillList(scope.row)"
            >结算</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="footer pager">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="formData.pageNumber"
          :page-size.sync="formData.pageSize"
          :page-sizes="[20, 30, 40, 50]"
          layout="total, sizes, prev, pager, next, jumper"
          :total.sync="total"
          background
        ></el-pagination>
      </div>
    </basic-container>
  </div>
</template>
<script>
import {dateTimeFormatter} from '@/utils/utils.js'

export default {
  //定义组件的初始数据
  data() {
    return {
      selectStore:'1',
      storeId1:"",
      storeId2:"",
      createTime:[],
      cusOption2:[],
      stores:[],
      formData: {
        // status: '-1',
        companyId: "",
        subjectName: "",
        pageNumber: 1,
        pageSize: 20,
        fromSource: "cs"
      },
      totalWaitSettleAmount: "",
      total: 0,
      loading: false,
      tableData: [],
      pickerOptions: {
          disabledDate(time) {
            let cur_time = new Date(new Date().toLocaleDateString()).getTime();
            return time.getTime() > cur_time + 86400000 - 1000;
          },
        },
    };
  },
  watch: {
    "storeId1":{
      handler: function(val) {
        this.formData.companyId = val
      }
    },
    "storeId2":{
      handler: function(val) {
        this.formData.companyId = val
      }
    }
  },

  beforeRouteEnter(to, from, next) {
    next(async vm => {
      try {
        vm.getList();
        vm.getTotalWaitSettleAmount();
      } catch (error) {
        console.log(error);
        next();
      }
    })
  },

  methods: {
    selectBtn(val){
      this.formData.companyId = this.storeId1
      if(val == "2"){
        this.formData.companyId = this.storeId2
      }
    },
    toDetail(row, type){
      if(row){
        this.$router.push({
          path: "/splitAccountManage/detail",
          query: {
            subjectId:row.id,
            type: type
          }
        });
      }
    },
    toBillList(row){
      if(row){
        this.$router.push({
          path: "/splitAccount/bill",
          query: {
            subjectId:row.id,
            status: "3"
          }
        });
      }
    },
    listCompany(row){
      if(row) {
        this.$router.push({
          path: "/splitAccountManage/company",
          query: {
            subjectId:row.id
          }
        });
      }
    },
    addCashAccount(row){
      if(row){
        this.$router.push({
          path: "/splitAccountManage/addCash",
          query: {
            subjectId:row.id
          }
        });
      }
    },
    removeCashAccount(row){//解绑银行卡
      this.$confirm("确认解绑银行卡？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(async () => {
        try {
          this.loading = true;
          const { ret, error } = await _api.splitAcc.cancelAccountCard({
            subjectId:row.id,
            id:row.payClearSettlementId
          });
          if (ret) {
            this.$message.warning("操作完成");
            await this.getList();
          } else {
            this.$message.warning(error);
          }
        } catch (e) {
          console.log(e);
          this.$message.error(e);
        } finally {
          this.loading = false;
        }
      }).catch(() => {
      });
    },
    shouldShowButton(row) {
      return (row.cashAccountCode === '' || !row.cashAccountCode) && row.state >= 3 && row.state < 5;
    },

    _formatDate (ct) {
      return ct ? dateTimeFormatter(ct*1000, 'YYYY-MM-DD HH:mm:ss') : '--'
    },

    subjectSearch(){
      this.search();
      this.getTotalWaitSettleAmount();
    },
    search() {
      this.formData.pageNumber = 1;
      this.getList();
    },

    addSubject() {
      this.$router.push("/splitAccountManage/addSubject");
    },
    
    async getList() {
      this.loading = true;
      const {
        data: { items, totalCount }
      } = await _api.splitAcc.getSubjectList(this.formData);
      if (items) {
        this.tableData = items || [];
        this.total = totalCount;
      } else {
        this.tableData = [];
        this.total = 0;
      }
      this.loading = false;
    },

    async getTotalWaitSettleAmount() {
      const {data}  = await _api.splitAcc.totalWaitSettlementAmount({});
      if(data) {
        this.totalWaitSettleAmount = data;
      }
      
    },

    // 重置
    reset() {
      this.formData.companyId = ""
      if(this.$refs["cusOption"]){
        this.$refs["cusOption"].reset()
      }
      this.$refs["splitAccountManage"].resetFields();
      this.createTime = []
    },
    handleCurrentChange(val) {
      this.getList();
    },
    handleSizeChange(val) {
      this.formData.pageNumber = 1;
      this.getList();
    },
    
  }
};
</script>
<style>
.img li{ 
  float:left;
  margin-left:5px; 
  list-style-type:none;
}
</style>